export enum BackendErrors {
  Authorization = 0,
  ConsentError = 1,
  Consent_Is_Empty = 2,
  Consent_Is_Registered = 3,
  CPR_Number_Is_Empty = 4,
  Integration_Token_Is_Empty = 5,
  No_Data = 6,
  Unexpected_Error = 7,
  Consent_Does_Not_Exist = 8,
  Invalid_Error_Response = 9,
  Deserialization_Error = 10,
  Invalid_CPR_Number = 11,
  Invalid_BFE_Number = 12,
  Invalid_Loan_type = 13,
  Connection_To_CSRP_Failed = 14,
  Connection_To_External_EDP_Failed = 15,
  Auth_Expired_Or_Missing = 16,
}
